import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { brand, brandList } from 'src/app/models/brand';
import { CommonResponse } from 'src/app/models/commomResponse';
import { ExportCsvResponse } from 'src/app/models/exportCsvResponst';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrandsService {
  constructor(private http: HttpClient) {}

  getBrandById(id: string): Observable<brand> {
    return this.http
      .get<{ data: brand }>(`${environment.base_url}getBrand/${id}`)
      .pipe(map(res => res.data));
  }

  addBrand(data: brand): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}addBrand`,
      data
    );
  }

  updateBrand(
    data: brand | { isBlocked: boolean },
    id: string
  ): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(
      `${environment.base_url}updateBrand/${id}`,
      data
    );
  }

  getBrandList(data: string): Observable<brandList> {
    return this.http
      .get<{ data: brandList }>(`${environment.base_url}getBrand?${data}`)
      .pipe(map(res => res.data));
  }

  getAllBrandList(vendorId: string = ''): Observable<any[]> {
    const url = vendorId ? `${environment.base_url}allBrand/${vendorId}` : `${environment.base_url}allBrand`;
    return this.http
      .get<{ data: Array<{ _id: string; name?: string }> }>(url)
      .pipe(map(res => res.data));
  }

  getAllVendorList(): Observable<any[]> {
    return this.http
      .get<{ data: any[] }>(`${environment.base_url}allVendors`)
      .pipe(map(res => res.data));
  }

  deleteBrand(id: string): Observable<number> {
    return this.http
      .delete<{
        statusCode: number;
      }>(`${environment.base_url}deleteBrand/${id}`)
      .pipe(map(res => res.statusCode));
  }
  exportCsv(query: string): Observable<ExportCsvResponse> {
    return this.http.get<ExportCsvResponse>(
      `${environment.base_url}brandExport?${query}`
    );
  }
}
